// extracted by mini-css-extract-plugin
export var character = "j_P";
export var pic = "j_Q";